(ns ycweb.app.dashboard.planning.planqtydifference
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.dashboard.planning.common :as planning.cmn]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.util.comms :as comms]))

(def store-quantity-differences-table-config
  {:table-name :admin.planning-new/table-plan-quantities
   :row-id :storename
   :data-source
   {:cursor [:admin.planning-new :different-quantities]}
   :options
   {:order :desc
    :sticky-header? true}

   :column-defs
   [{:key :storename
     :title "Store Name"}
    {:key :storeplanqty
     :title "Store Plan Quantity"}
    {:key :storestockqty
     :title "Store Stock Quantity"}
    {:key :difference
     :title "Difference"
     :render
     {:render-k :difference-fn}}]})

(def store-quantity-differences-table-fns
  {:column-fns
   {:difference-fn
    (fn [_ row _ _]
      (- (:storeplanqty row) (:storestockqty row)))}})

(rum/defc plan-qty-difference < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [product-name variation-name feature1 feature2]} (cmn/curact process-atom :product-info)]
    [:<>
     [:div.admin-react-wrapper__content
      (headings/heading
        "Stores: Understocked, Overstocked"
        {:type :h1 :size :large})

      [:p
       {:class (u/bem :yc-paragraph [:large :flush])}
       [:b "Product: "]
       (str product-name
         (when (u/presence feature1) (str " | " feature1))
         (when (u/presence feature2) (str " | " feature2)))]

      [:p
       {:class (u/bem :yc-paragraph [:large])}
       [:b  "SKU: "]
       variation-name]]

     [:div
      (datatables/table app-atom
        :admin.planning-new/table-plan-quantities
        store-quantity-differences-table-fns)]]))

(defmethod comms/receive :admin.planning-new/plan-qty-diff
  [app-atom {:keys [different-quantities]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc-in [:different-quantities]
      (u/index-by :storename different-quantities))))

(defmethod t/transition-open :admin.planning-new/plan-qty-difference
  [app-atom _ {:keys [vid product-name feature2 feature1 variation-name] :as params}]
  (when-not (w.cmn/redirect-to-new-layout-if-needed! app-atom "planning" params)
    (toaster/open-overlay app-atom :admin.planning-new/plan-qty-difference)
    (comms/send :admin.planning-new/plan-qty-diff {:vid vid})
    (datatables/initiate app-atom store-quantity-differences-table-config {})
    (swap! (cmn/process-cursor app-atom) assoc :product-info
      {:product-name product-name
       :variation-name variation-name
       :feature1 feature1
       :feature2 feature2})))

(defmethod t/transition-after-open :admin.planning-new/plan-qty-difference [app-atom _ _]
  (presence/open app-atom {:context/ident :admin.stockmovement}))

;; No button row on this screen to sit alongside, so the toggle floats top-right.
(defmethod flow/render-screen :admin.planning-new/plan-qty-difference [app-atom _]
  (planning.cmn/with-loading-overlay app-atom
    [:div {:style {:position "relative"}}
     [:div {:style {:position "absolute" :top 0 :right 0 :z-index 1}}
      (buttons/button-web "Try new layout"
         (merge
           (w.cmn/try-new-layout-props)
           {:style :light
            :size :small}))]
     (plan-qty-difference app-atom)]))